import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgShow(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="4 0 16 24" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12 6c2.946 0 5.612 2 8 6-2.388 4-5.054 6-8 6-2.946 0-5.612-2-8-6 2.388-4 5.054-6 8-6zm0 2c-1.86 0-3.697 1.203-5.508 3.817L6.368 12l.124.183c1.747 2.521 3.516 3.73 5.309 3.812L12 16c1.86 0 3.697-1.203 5.508-3.817L17.63 12l-.123-.183c-1.747-2.521-3.516-3.73-5.309-3.812L12 8zm0 2a2 2 0 11.001 3.999A2 2 0 0112 10z"
      />
    </svg>
  );
}

export default tombacIcon('Show')(SvgShow);
